










import {Component, Prop, Vue} from "vue-property-decorator";
import SidebarContent from "./SidebarContent.vue";

@Component({
    name: 'SidebarDesktop',
    components: { SidebarContent }
})
export default class extends Vue {
    @Prop({ required: true })
    private collapsed!: boolean;

    get _collapsed(): boolean {
        return this.collapsed;
    }

    get visibleTitle(): boolean {
        return !this.collapsed;
    }
}
